export const getPercentage = (value = 0, total = 0) => {
    if (!total) return 0;

    return Math.round((value / total) * 100);
};
